
















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

type AlertVariant = "danger" | "info" | "success";

@Component
export default class Alert extends Vue {
  @Prop({ default: "danger" })
  public variant!: AlertVariant;
}
